import { CouponService } from './../../../../services/coupon.service';
import { Component, OnInit } from '@angular/core';
import { AppSetting } from './../../../../global/appsetting';
import { LoaderService } from './../../../../services/loader.service';
import { GaAnalyticsService, EVENT_TYPES } from 'src/app/services/ga-analytics.service';
import { CouponCode, CouponView, Coupon } from 'src/app/models/coupons/coupons';

@Component({
  selector: 'app-create-coupon-code',
  templateUrl: './create-coupon-code.component.html',
  styleUrls: ['./create-coupon-code.component.scss']
})
export class CreateCouponCodeComponent implements OnInit {
  couponCode: CouponCode;
  couponLeft: number;
  captchaResponse = '';
  recaptchaKey: string;
  CouponView: CouponView;
  currentCoupon: Coupon;
  displayDoublesError = false;
  displaySuccessError = false;
  displayGeneralError = false;
  fieldsToValidate = [false, false, false];
  enableClick = true;
  displayGoogleRobot = true;
  UserEmailCopy = '';
  constructor(public couponService: CouponService,
    public appsetting: AppSetting,
    public loaderService: LoaderService,
    private gaAnalyticsService: GaAnalyticsService) {
    this.recaptchaKey = this.appsetting.reCaptchaKey;
  }

  ngOnInit() {
    this.couponCode = new CouponCode();
    this.loaderService.displayLoader(false);
    this.couponService.GetAllActiveCoupons().subscribe((res: Array<Coupon>) => {
      this.loaderService.hideLoader();
      if (res != null && res.length > 0) {
        this.couponService.listOfAvailbleCoupons = res;
        this.couponLeft = res[0].MaxCouponCodes - res[0].CouponCodeUses;
        this.currentCoupon = res[0];
      }
    }, error => {
      this.gaAnalyticsService.logEventToGa('ngOnInit', 'CreateCouponCodeComponent', EVENT_TYPES.Error); 
    }
    );
  }
  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;

    console.log(`Resolved captcha with response ${captchaResponse}:`);
  }
  couponChange(event) {
    this.couponCode.CouponId = event.target.value;
    for (let i = 0; i < this.couponService.listOfAvailbleCoupons.length; i++) {
      if (this.couponService.listOfAvailbleCoupons[i].Id === this.couponCode.CouponId) {
        this.couponLeft = this.couponService.listOfAvailbleCoupons[i].MaxCouponCodes - this.couponService.listOfAvailbleCoupons[i].CouponCodeUses;
        this.currentCoupon = this.couponService.listOfAvailbleCoupons[i];
      }
    }
  }
  send() {
    if (this.validateFields()) {
      this.CouponView = new CouponView();
      this.CouponView.Coupon = this.currentCoupon;
      this.CouponView.CouponCode = this.couponCode;
      this.loaderService.displayLoader(false);
      this.displayDoublesError = false;
      this.displaySuccessError = false;
      this.displayGeneralError = false;
      this.couponService.InsertCodeCoupon(this.CouponView, this.captchaResponse).subscribe((res: string) => {
        this.loaderService.hideLoader();
        if (res !== '-1' && res !== '') {
          this.displaySuccessError = true;
          this.couponService.listOfAvailbleCoupons = new Array<Coupon>();
        } else if (res === '-1') {
          this.displayDoublesError = true;
        } else {
          this.displayGeneralError = true;
        }
        this.couponService.displayCouponCodeForm = false;
        this.displayGoogleRobot = false;
        window.setTimeout(() => {
          this.displayGoogleRobot = true;
        }, 1000);
      }, error => {
        this.gaAnalyticsService.logEventToGa('send', 'CreateCouponCodeComponent', EVENT_TYPES.Error); 
        this.loaderService.hideLoader();
        this.displayGeneralError = true;
        this.displayGoogleRobot = false;
        window.setTimeout(() => {
          this.displayGoogleRobot = true;
        }, 1000);
      });
    }

  }
  validateFields() {
    let res = true;
    this.fieldsToValidate = [false, false, false];
    if (this.captchaResponse === '') {
      this.fieldsToValidate[1] = true;
      res = false;
    }
    // tslint:disable-next-line: max-line-length
    const pattern = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.couponCode.UserEmail === '' || !pattern.test(String(this.couponCode.UserEmail).toLowerCase())) {
      this.fieldsToValidate[0] = true;
      res = false;
    } else if (this.UserEmailCopy !== this.couponCode.UserEmail) {
      this.fieldsToValidate[2] = true;
      res = false;
    }
    return res;
  }

  closeWindow() {
    this.couponService.displayCouponCodeForm = false;
  }
  preventDefault() {
    this.enableClick = false;
  }
  clickOnBlankarea() {
    if (this.enableClick) {
      this.couponService.displayCouponCodeForm = false;
    }
    this.enableClick = true;
  }
}
